import { FacilityDropdownInput } from "#src/batteries-included-components/Dropdowns/FacilityDropdownInput";
import useLocalization from "#src/hooks/useLocalization";
import {
  DropdownInput,
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import { Events } from "@validereinc/domain-controllers";
import React from "react";

export const SUPPORTED_EVENTS_FILTERS = [
  "name",
  "status",
  "associated_facility.id",
  "description",
];

const { EventStatusOptions } = Events.view;

export const EventsFilterPanel = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  const { localize } = useLocalization();

  return (
    <FilterPanel
      storageKey={filterConfigStorageKey}
      defaultActiveKeys={["Filters"]}
      filters={[
        {
          component: (
            <TextInput
              name={SUPPORTED_EVENTS_FILTERS[0]}
              key="event-template-name-filter"
              placeholder="Search Events..."
              type="search"
              isInline
            />
          ),
        },
        {
          component: (
            <DropdownInput
              name={SUPPORTED_EVENTS_FILTERS[1]}
              key="event-template-status-filter"
              options={EventStatusOptions}
              placeholder="Select a Status"
              labelKey="label"
              valueKey="value"
              isInline
              isMulti
              isOptionalTextShown={false}
            />
          ),
        },
        {
          component: (
            <FacilityDropdownInput
              name={SUPPORTED_EVENTS_FILTERS[2]}
              label={`Associated ${localize("Facility")}`}
              key="event-associated-facility-filter"
              placeholder={`Select a ${localize("Facility")}`}
              isOptionalTextShown={false}
              isInline
              isLabelShown={false}
            />
          ),
        },
        {
          component: (
            <TextInput
              name={SUPPORTED_EVENTS_FILTERS[3]}
              label="Description"
              type="search"
              isLabelShown={false}
              isInline
              placeholder="Search Description..."
              isOptionalTextShown={false}
            />
          ),
        },
      ]}
    />
  );
};
